import React from "react";
import { toast } from "react-toastify";
import FormComponent from "./common/formComponent";
import { getCurrentUser } from "../services/authService";
import { getVerificationToken } from "../services/authService";
import PageLoading from "./common/pageLoading";
import { logout } from "../services/authService";
import EmailVerification from "./emailVerification";
import SetNewPassword from "./setNewPassword";

class ResetPassword extends FormComponent {
  state = {
    verificationToken: "",
    loading: "",
  };

  constructor() {
    super();
    this.state.loading = true;
  }

  async componentDidMount() {
    const tokenId = this.props.match.params.tokenId;
    if (tokenId) {
      try {
        const { data: verificationToken } = await getVerificationToken(tokenId);

        this.setState({ verificationToken });
      } catch (ex) {
        if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
          toast.error(ex.response.data);
        }
      }
    }
    this.setState({ loading: false });
  }

  render() {
    if (getCurrentUser()) {
      logout();
    }

    const { loading, verificationToken } = this.state;

    return (
      <React.Fragment>
        <PageLoading loading={loading} />
        {!verificationToken && !loading && <EmailVerification />}
        {verificationToken && !loading && <SetNewPassword verificationToken={verificationToken} {...this.props} />}
      </React.Fragment>
    );
  }
}

export default ResetPassword;
